import type { CollectionHistoricalPositionResponseModel } from "@/features/collections/api/useCollectionHistoricalPositions";
import { useHTTP, useHTTPQuery } from "@/lib/http";

export const useDashboardHistoricalPositions = (days: number) => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["dashboardHistoricalPositions", days],
		queryFn: () => http<CollectionHistoricalPositionResponseModel[]>({
			method: "GET",
			url: `/collection/dashboard/historical-positions?days=${days}`
		}),
		placeholderData: x => x
	});
};
